/* NTRL1 · carrusel de historias + "Ver más" en reseñas */
(function () {
  if (window.__ntrlExtras) return;
  window.__ntrlExtras = true;

  var ICON_PREV = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
  var ICON_NEXT = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  /* ---------- Carrusel ---------- */
  function setupCarousel(track) {
    if (track.dataset.ntrlCar) return;
    track.dataset.ntrlCar = '1';
    track.classList.add('is-carousel');

    var wrap = document.createElement('div');
    wrap.className = 'ntrl-car';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);

    var nav = document.createElement('div');
    nav.className = 'ntrl-car__nav';
    nav.innerHTML =
      '<button type="button" class="ntrl-round-btn" data-dir="-1" aria-label="Historia anterior">' + ICON_PREV + '</button>' +
      '<button type="button" class="ntrl-round-btn ntrl-round-btn--solid" data-dir="1" aria-label="Historia siguiente">' + ICON_NEXT + '</button>';
    wrap.appendChild(nav);
    var prev = nav.children[0], next = nav.children[1];

    function step() {
      var card = track.querySelector('.ntrl-rcard');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-dir]');
      if (!b) return;
      track.scrollBy({ left: step() * parseInt(b.dataset.dir, 10), behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 400);
  }

  /* ---------- "Ver más" ---------- */
  function closeModal(m) {
    m.remove();
    document.documentElement.style.overflow = '';
  }
  function openModal(card) {
    var m = document.createElement('div');
    m.className = 'ntrl-rmodal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    var box = document.createElement('div');
    box.className = 'ntrl ntrl-rmodal__box';
    var clone = card.cloneNode(true);
    clone.removeAttribute('data-shopify-editor-block');
    var rm = clone.querySelector('.ntrl-readmore');
    if (rm) rm.remove();
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'ntrl-rmodal__close';
    x.setAttribute('aria-label', 'Cerrar');
    x.innerHTML = '&times;';
    box.appendChild(clone);
    box.appendChild(x);
    m.appendChild(box);
    document.body.appendChild(m);
    document.documentElement.style.overflow = 'hidden';
    x.focus();
    m.addEventListener('click', function (e) { if (e.target === m || e.target === x) closeModal(m); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { closeModal(m); document.removeEventListener('keydown', esc); }
    });
  }

  function checkCard(card) {
    var p = card.querySelector(':scope > p');
    if (!p || card.classList.contains('is-open')) return;
    var btn = card.querySelector(':scope > .ntrl-readmore');
    if (p.clientHeight === 0) return; /* oculta todavía */
    var h3 = card.querySelector(':scope > h3');
    var cut = p.scrollHeight > p.clientHeight + 2 || (h3 && h3.scrollHeight > h3.clientHeight + 2);
    if (cut && !btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ntrl-readmore';
      btn.textContent = 'Ver más';
      p.insertAdjacentElement('afterend', btn);
      btn.addEventListener('click', function () {
        if (card.classList.contains('ntrl-rcard')) {
          openModal(card);
        } else {
          var open = card.classList.toggle('is-open');
          btn.textContent = open ? 'Ver menos' : 'Ver más';
        }
      });
    } else if (!cut && btn) {
      btn.remove();
    }
  }
  function checkAll() {
    document.querySelectorAll('.ntrl-rcard, .ntrl-ritem').forEach(checkCard);
  }

  function init() {
    document.querySelectorAll('.ntrl-reviews3').forEach(setupCarousel);
    checkAll();
    setTimeout(checkAll, 600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', checkAll);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(checkAll, 150); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ntrl-more]')) setTimeout(checkAll, 80);
  });

  /* Editor del tema */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el && el.classList && el.classList.contains('ntrl-rcard')) {
      var track = el.closest('.ntrl-reviews3');
      if (track) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
  });
})();
